export const services = [
  {
    slug: "bureaux",
    icon: "Building2",
    title: "Nettoyage de bureaux",
    short:
      "Entretien quotidien ou périodique de vos espaces de travail : sols, sanitaires, salles de réunion, cuisines.",
    details: [
      "Aspiration et lavage des sols",
      "Dépoussiérage du mobilier et écrans",
      "Nettoyage et désinfection des sanitaires",
      "Vidage des corbeilles et tri sélectif",
      "Approvisionnement en consommables",
    ],
  },
  {
    slug: "commerciaux",
    icon: "Store",
    title: "Nettoyage de locaux commerciaux",
    short:
      "Boutiques, restaurants, salons de coiffure — un environnement irréprochable pour accueillir vos clients.",
    details: [
      "Nettoyage vitrines et sols de vente",
      "Entretien des surfaces de contact",
      "Interventions avant ou après ouverture",
      "Traitement des odeurs et désinfection",
    ],
  },
  {
    slug: "apres-travaux",
    icon: "Hammer",
    title: "Nettoyage après travaux",
    short:
      "Élimination des poussières, résidus de peinture et gravats pour livrer un chantier propre et exploitable.",
    details: [
      "Dépoussiérage complet des surfaces",
      "Décapage des sols et vitres",
      "Retrait des étiquettes et traces de colle",
      "Livraison clé en main",
    ],
  },
  {
    slug: "vitrerie",
    icon: "Sparkle",
    title: "Nettoyage de vitrerie",
    short:
      "Vitres, baies et façades vitrées — intervention en hauteur avec équipement homologué.",
    details: [
      "Vitres intérieures et extérieures",
      "Nettoyage à la perche télescopique",
      "Cordistes pour bâtiments en hauteur",
      "Encadrements et rebords compris",
    ],
  },
  {
    slug: "remise-en-etat",
    icon: "Layers",
    title: "Remise en état",
    short:
      "Nettoyage approfondi de locaux dégradés, avant location, ou en sortie de bail.",
    details: [
      "Décapage et cristallisation des sols",
      "Traitement des moquettes",
      "Détartrage complet des sanitaires",
      "Rafraîchissement complet",
    ],
  },
  {
    slug: "copropriete",
    icon: "Building2",
    title: "Entretien copropriétés",
    short:
      "Parties communes, halls d'entrée, escaliers, parkings — pour des immeubles agréables au quotidien.",
    details: [
      "Nettoyage des halls et cages d'escalier",
      "Sortie et rentrée des containers",
      "Nettoyage des parkings",
      "Vitres et miroirs communs",
    ],
  },
];

export const serviceOptions = [
  "Nettoyage de bureaux",
  "Nettoyage de locaux commerciaux",
  "Nettoyage après travaux",
  "Nettoyage de vitrerie",
  "Remise en état",
  "Entretien copropriétés",
  "Autre",
];

export const frequencyOptions = [
  "Ponctuel (une seule fois)",
  "Quotidien",
  "Plusieurs fois par semaine",
  "Hebdomadaire",
  "Bi-mensuel",
  "Mensuel",
];
